import {
  ILoginPayload,
  loginWithProvider,
  OAUTH_GRANT_TYPE,
  PRODUCT_TYPE,
  SOCIAL_LOGIN_PROVIDER,
} from '../../../../modules/auth'
import { DEFAULT_LOCALE, LOCALE_KEY } from '../../../../modules/i18n/config'
import { SOCIAL_LOGIN_PREFIX } from '../../../../modules/vars'
import useAppRouter from '../../common/useAppRouter'

export default function useAppleLogin(locale, isMobile) {
  const router = useAppRouter()
  // STUDENT
  const responseApple = async (response) => {
    if (response) {
      const payload: Omit<ILoginPayload, 'google_token_type'> = {
        grant_type: OAUTH_GRANT_TYPE.PASSWORD,
        username: SOCIAL_LOGIN_PREFIX + SOCIAL_LOGIN_PROVIDER.APPLE,
        password: response.authorization?.id_token,
        locale: locale == LOCALE_KEY ? DEFAULT_LOCALE : locale,
        product_type: PRODUCT_TYPE.PLUS,
      }
      await loginWithProvider(router, payload, isMobile, null, SOCIAL_LOGIN_PROVIDER.APPLE)
    } else {
      if (response.details) {
        alert(response.details)
      } else {
        alert(response.error)
      }
    }
  }

  return responseApple
}
